import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import type { FilterKey } from 'teacher-ui-client/reading-scales/utils'
import { ModalTab as BookModalTab } from 'teacher-ui-client/components/book-library/book-modal'

export default class BookLibrarySearchController extends Controller {
  queryParams = ['primaryFilterKey', 'primaryFilterValue', 'keywords', 'categories', 'withinCategories', 'excluded']

  // component.ensurePrimaryFilterKeySet hook defaults this to first filter key, if not set
  @tracked primaryFilterKey!: FilterKey

  /**
   * a string representation of the from/to values for the primary filter, leave from/to undefined and defaults will be
   * inferred from current primary filter.
   *
   * The from/to values are the indices of the chosen options from the selected primary filters' options array
   */
  @tracked primaryFilterValue = ':'

  @tracked categories: string[] = []

  @tracked withinCategories: string[] = []

  @tracked keywords = ''

  @tracked excluded: boolean | undefined = false

  BookModalTab = BookModalTab
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/book-library/search': BookLibrarySearchController
  }
}
